import { useState } from "react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useTranslation from "next-translate/useTranslation";
import setLanguage from "next-translate/setLanguage";
import { Avatar } from "@/components/core";

export function LanguageSelected() {
  const { lang } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (value: any) => {
    setLanguage(value);
    handleClose();
  };

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 0.5,
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          {lang.toUpperCase()}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 18,
            color: "text.secondary",
          }}
        />
        <Avatar
          sx={{
            height: 30,
            width: 30,
            "& img": {
              objectFit: "cover",
              objectPosition: "30% center",
            },
          }}
          src={`/svg/${lang}.svg`}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 2,
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          },
        }}
      >
        {["tr", "en"].map((code) => (
          <MenuItem
            key={code}
            onClick={() => handleChange(code)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 2,
              py: 1,
            }}
          >
            <Box
              component="img"
              src={`/images/flags/${code}-flag.png`}
              sx={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <Typography fontSize={14}>{code.toUpperCase()}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
